'use client';
var PluginsStatusTracker = function(options) {
    var track = function track(param) {
        var id = param.id;
        bus.emit("plugin-tracked", id);
        return statuses.set(id, false);
    };
    var activate = function activate(param) {
        var id = param.id;
        bus.emit("plugin-activated", id);
        return statuses.set(id, true);
    };
    var isTracked = function isTracked(param) {
        var id = param.id;
        return statuses.has(id);
    };
    var isActive = function isActive(param) {
        var id = param.id;
        return statuses.get(id);
    };
    var untrack = function untrack(param) {
        var id = param.id;
        statuses.delete(id);
        bus.emit("plugin-untracked", id);
    };
    var bus = options.bus;
    var supervisor = {
        track: track,
        isTracked: isTracked,
        untrack: untrack,
        activate: activate,
        isActive: isActive
    };
    var statuses = new Map();
    return supervisor;
};

export { PluginsStatusTracker };
